import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  ElementRef,
  HostListener,
  Injector,
  input,
  output,
  Renderer2,
  signal,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

import { InfoIcon } from '../info-icon';

@Component({
  selector: 'fz-card-details',
  standalone: true,
  imports: [],
  templateUrl: './card-details.html',
  styleUrl: './card-details.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'fz-card-details',
  },
})
export class CardDetails {}

@Directive({
  selector: 'fz-card-item, [fz-card-item], [fzCardItem]',
  standalone: true,
  host: {
    class: 'fz-card-details__item',
  },
})
export class CardDetailsItem {}

@Directive({
  selector:
    'fz-card-expansion-item, [fz-card-expansion-item], [fzCardExpansionItem]',
  standalone: true,
  host: {
    class: 'fz-card-details__item fz-card-details__item__expand',
    '[class.fz-card-details__item--expanded]': 'isExpanded()',
  },
})
export class CardDetailsExpansionItem {
  hideToggle = input<boolean>(false);
  isExpanded = signal<boolean>(false);
  opened = output<void>();
  closed = output<void>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('click')
  toggleExpand() {
    this.isExpanded.update((value) => !value);

    if (this.isExpanded()) {
      this.opened.emit();
    } else {
      this.closed.emit();
    }
  }

  ngOnInit(): void {
    this.addExpandedIcon();
  }

  private createExpandedIcon() {
    const icon = this.renderer.createElement('mat-icon');
    icon.innerText = 'expand_more';

    'expand_icon mat-icon material-icons mat-ligature-font mat-icon-no-color'
      .split(' ')
      .forEach((className) => this.renderer.addClass(icon, className));

    return icon;
  }

  private addExpandedIcon() {
    const el = this.el.nativeElement;
    const icon = this.createExpandedIcon();

    this.renderer.appendChild(el, icon);
  }
}

@Directive({
  selector: `fz-card-item-title, [z-card-item-title], [fzCardItemTitle]`,
  standalone: true,
  host: { class: 'fz-card-details__item__title' },
})
export class CardDetailsRowTitle {
  info = input<string>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private vcr: ViewContainerRef,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    if (this.info()) {
      this.addIcon();
    }
  }

  private addIcon() {
    const infoIcon = this.vcr.createComponent(InfoIcon, {
      injector: this.injector,
    });
    infoIcon.instance.info = this.info;

    this.renderer.appendChild(
      this.el.nativeElement,
      infoIcon.location.nativeElement,
    );
  }
}

@Directive({
  selector: `fz-card-item-description, [fz-card-item-description], [fzCardItemDescription]`,
  standalone: true,
  host: { class: 'fz-card-details__item__description' },
})
export class CardDetailsRowDescription {}

@Directive({
  selector: `fz-card-item-body, [fz-card-item-body], [fzCardItemBody]`,
  standalone: true,
  host: { class: 'fz-card-details__item__body' },
})
export class CardDetailsRowBody {}

@Directive({
  selector: `fz-card-actions, [fz-card-actions], [fzCardActions]`,
  standalone: true,
  host: { class: 'fz-card-details__actions' },
})
export class CardDetailsActions {}
